module.exports = __webpack_public_path__ + "img/typography-01.19c63e0f.png";